import { Download } from 'lucide-react';
import { Button } from '../components/ui/button';
import { memo, useCallback } from 'react';
import { renderTextWithLinks } from '../utils/renderTextWithLinks';

type VideoMessageProps = {
  videoSrc: string;
  onClick: () => void;
  caption?: string;
};

// Extrai nome do arquivo sem o timestamp token
const getCleanFileName = (path: string) => {
  const fileName = path.split('?')[0].split('/').pop() || 'video.mp4';
  return fileName.replace(/^\d+-/, '');
};

export const VideoMessage = memo(function VideoMessage({
  videoSrc,
  onClick,
  caption,
}: VideoMessageProps) {
  const handleDownload = useCallback(async () => {
    try {
      const response = await fetch(videoSrc);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = blobUrl;
      a.download = getCleanFileName(videoSrc);
      a.style.display = 'none';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      setTimeout(() => URL.revokeObjectURL(blobUrl), 100);
    } catch (error) {
      console.error('Erro ao baixar vídeo:', error);
      window.open(videoSrc, '_blank');
    }
  }, [videoSrc]);

  return (
    <div className="flex flex-row items-center gap-2">
      <div
        className="relative cursor-pointer"
        onClick={onClick}
        title="Ver vídeo"
      >
        <div className="flex flex-col gap-2">
          <video
            src={videoSrc}
            className="rounded-md max-w-full sm:max-w-xs my-1 bg-black"
            style={{ maxHeight: 180 }}
            controls={false}
          />
          {caption && (
            <div className="flex flex-col">
              <hr className="w-full border-gray-200" />
              <p className="text-gray-800 dark:text-gray-100 break-words whitespace-pre-wrap">
                {renderTextWithLinks(caption)}
              </p>
            </div>
          )}
        </div>
        <div className="absolute inset-0 flex items-center justify-center">
          <Button
            variant="ghost"
            size="icon"
            className="bg-black/60 text-white"
            title="Reproduzir vídeo"
          >
            <svg width="32" height="32" fill="currentColor" viewBox="0 0 24 24">
              <polygon points="8,5 19,12 8,19" />
            </svg>
          </Button>
        </div>
      </div>
      <div className="flex gap-2 mt-1">
        <Button
          variant="ghost"
          size="icon"
          className="text-gray-600 dark:text-gray-300"
          title="Baixar vídeo"
          onClick={handleDownload}
        >
          <Download size={20} />
        </Button>
      </div>
    </div>
  );
});
